import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';
import CreateCadmin from './CreateCadmin';
import swal from 'sweetalert';

class ListLicense extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_data_available: false,
            l_obj: {},
            c_id: ''
        }
    }
    componentDidMount() {

        var c_id = sessionStorage.getItem('listlicense')
        this.setState({ c_id: c_id })
        if (c_id) {
            this.getTotalCAdmin(c_id)
        } else {
            window.location.href = '/create/listcadmin'
        }

    }
    getTotalCAdmin = (c_id) => {
        var data = {
            c_id: c_id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/fetchLicenseDetails`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    if (response.data.completeLicense) {
                        _this.setState({ l_obj: response.data.completeLicense, is_data_available: true });
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalCAdmin();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                logo: reader.result
            });

        };
    }
    ActivateLicense = () => {
        var data = {
            license_id: this.state.l_obj.license_id,
            c_id: this.state.c_id
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/activateLicense`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    swal(response.data.message, "", "success");
                    setTimeout(() => { window.location.href = '/create/listcadmin' }, 1000)

                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalCAdmin();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    render() {

        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h4 class="xp-page-title">License</h4>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">

                                    {Object.keys(this.state.l_obj).length > 1 ?
                                        this.state.l_obj.activated_license == 1 ?
                                            <p class="text-success">Activated License </p>
                                            :
                                            <button className="btn btn-primary btn-lg active" onClick={this.ActivateLicense}>Activate License</button>
                                        : null
                                    }

                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.is_data_available ?
                    <div class="xp-contentbar">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="card m-b-30">
                                    <div className="row " style={{ padding: "2%" }}>
                                        <div className="col-lg-12 ">
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Application Dashboard</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Enable Themes : {this.state.l_obj.application_Dashboard.enable_themes == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}

                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Analytics : {this.state.l_obj.application_Dashboard.enable_analytics == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Updates : {this.state.l_obj.application_Dashboard.enable_updates == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Organization Management</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Total Sites : {this.state.l_obj.organizationManagement.total_sites}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Sites Usage : {this.state.l_obj.organizationManagement.total_sites_usage}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Users : {this.state.l_obj.organizationManagement.total_users}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Users Usage : {this.state.l_obj.organizationManagement.total_users_usage}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Duration : {this.state.l_obj.organizationManagement.duration} Days
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Duration Usage : {this.state.l_obj.organizationManagement.duration_usage} Days
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Storage : {this.state.l_obj.organizationManagement.total_storage}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Storage Usage : {this.state.l_obj.organizationManagement.total_storage_usage}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">My Assist</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Enable Con Call : {this.state.l_obj.myAssist.enable_con_call == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Annotation : {this.state.l_obj.myAssist.enable_annotation == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Screen Share : {this.state.l_obj.myAssist.enable_screen_share == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Chat : {this.state.l_obj.myAssist.enable_chat == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Workflow</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Total Workflow : {this.state.l_obj.workflow.workflow_total}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Workflow Usage : {this.state.l_obj.workflow.workflow_usage}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Total Workflow Step : {this.state.l_obj.workflow.workflow_steps_total}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Evidence : {this.state.l_obj.workflow.enable_evidence == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Local Save : {this.state.l_obj.workflow.enable_local_save == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Without Watermark : {this.state.l_obj.workflow.enable_without_watermark == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Hardware</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Enable Android : {this.state.l_obj.hardware.enable_android == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Ios : {this.state.l_obj.hardware.enable_ios}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Desktop : {this.state.l_obj.hardware.enable_desktop == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Realwear : {this.state.l_obj.hardware.enable_realwear == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                        <div className="form-group  col-md-6">
                                                            Enable Hololens : {this.state.l_obj.hardware.enable_hololens == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Viewer</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Enable All Formats : {this.state.l_obj.viewer.enable_all_formats == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card m-b-30">
                                                <div className="card-header">
                                                    <h4 className="text-black">Recorder</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="form-row">
                                                        <div className="form-group  col-md-6">
                                                            Enable Record All Formats : {this.state.l_obj.recorder.enable_record_all_formats == 1 ? <i class="fa fa-check-circle text-success"></i> : <i class="fa fa-times-circle text-danger"></i>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        )
    }
}
export default ListLicense

